/**
 * Paddy Power Betfair Game Client JS API
 * version 1.0.8
 *
 * Copyright 2015-2022 Paddy Power Betfair.
 */

/*global window, top, document, arguments*/

/**
 *  addEventListener polyfill 1.0 / Eirik Backer / MIT Licence
 *  slightly modified for JSLint compliance
 *  @link https://gist.github.com/eirikbacker/2864711
 */
(function (win, doc) {
    "use strict";
    //No need to polyfill
    if (win.addEventListener) {
        return;
    }

    function addEvent(on, fn, self) {
        self = this;
        return self.attachEvent('on' + on, function (e) {
            var ev = e || win.event;
            ev.preventDefault = ev.preventDefault || function () {
                ev.returnValue = false;
            };
            ev.stopPropagation = ev.stopPropagation || function () {
                ev.cancelBubble = true;
            };
            fn.call(self, ev);
        });
    }

    function addListen(obj) {
        var i = obj.length;
        if (i) {
            while (--i) {
                obj[i].addEventListener = addEvent;
            }
        } else {
            obj.addEventListener = addEvent;
        }
        return obj;
    }

    function documentHijack(p) {
        var old = doc[p];
        doc[p] = function (v) {
            return addListen(old(v));
        };
    }

    addListen([doc, win]);

    //IE8
    if (win.hasOwnProperty('Element')) {
        win.Element.prototype.addEventListener = addEvent;
    } else { //IE < 8
        //Make sure we also init at domReady
        doc.attachEvent('onreadystatechange', function () {
            addListen(doc.all);
        });
        documentHijack('getElementsByTagName');
        documentHijack('getElementById');
        documentHijack('createElement');
        addListen(doc.all);
    }
}(window, document));

/**
 * Constants definition
 */
(function (win) {
    "use strict";
    win.com = win.com || {};
    win.com.ppb = win.com.ppb || {};
    win.com.ppb.constants = win.com.ppb.constants || {};

    /**
     * For backwards compatibility
     */
    win.com.betfair = win.com.ppb;

    var constants = win.com.ppb.constants;

    /** @const */
    constants.GAME_CLIENT = "gameClient";
    /** @const */
    constants.NATIVE_CLIENT_IOS = "nativeClientIos";
    /** @const */
    constants.NATIVE_IOS_WEBKIT = "nativeClientIosWebKit";
    /** @const */
    constants.NATIVE_IOS_WEBVIEW = "nativeClientIosWebView";
    /** @const */
    constants.NATIVE_IOS_APP_NAME = "nativeGameWindow";
    /** @const */
    constants.GAME_WINDOW = "gameWindow";
    /** @const */
    constants.GAME_INIT = "gameInit";
    /** @const */
    constants.GAME_SETUP = "gameSetup";
    /** @const */
    constants.GAME_LOAD_STARTED = "gameLoadStarted";
    /** @const */
    constants.GAME_LOAD_PROGRESS = "gameLoadProgress";
    /** @const */
    constants.GAME_LOAD_COMPLETED = "gameLoadComplete";
    /** @const */
    constants.GAME_ANIMATION_START = "gameAnimationStart";
    /** @const */
    constants.GAME_ANIMATION_COMPLETED = "gameAnimationComplete";
    /** @const */
    constants.REQUEST_GAMEWINDOW_CONFIG = "requestGameWindowConfig";
    /** @const */
    constants.RECEIVE_GAMEWINDOW_CONFIG = "receiveGameWindowConfig";
    /** @const */
    constants.BALANCE_UPDATE = "balanceUpdate";
    /** @const */
    constants.WIN_UPDATE = "winUpdate";
    /** @const */
    constants.JACKPOT_WIN_UPDATE = "jackpotWinUpdate";
    /** @const */
    constants.STAKE_UPDATE = "stakeUpdate";
    /** @const */
    constants.TOGGLE_MENU = "toggleMenu";
    /** @const */
    constants.TOGGLE_PAYTABLE = "togglePaytable";
    /** @const */
    constants.SETTINGS_UPDATE = "settingsUpdate";
    /** @const */
    constants.BALANCE_CHANGED = "balanceChanged";
    /** @const */
    constants.NOTIFY_ACTION = "notifyAction";
    /** @const */
    constants.SEND_EVENT = "sendEvent";
    /** @const */
    constants.ERROR_MESSAGE = "errorMessage";
    /** @const */
    constants.TYPE_STRING = "string";
    /** @const */
    constants.TYPE_NUMBER = "number";
    /** @const */
    constants.TYPE_OBJECT = "object";
    /** @const */
    constants.TYPE_BOOLEAN = "boolean";
    /** @const */
    constants.EVENT_EXIT_GAME = "exitGame";
    /** @const */
    constants.IMMEDIATE_EXIT_GAME = "immediateExitGame";
    /** @const */
    constants.EVENT_ITALY_RESOLVE_COMPLETE = "italyResolveComplete";
    /** @const */
    constants.GO_TO_GAME = "goToGame";
    /** @const */
    constants.GAMING_SESSION_DETAILS = "gamingSessionDetails";
    /** @const */
    constants.SESSION_DETAILS_MESSAGE = "sessionDetailsMessage";
    /** @const */
    constants.PLAY_MODE_UPDATE = "playModeUpdate";
    /** @const */
    constants.STOP_AUTO_SPIN = "stopAutoSpin";
    /** @const */
    constants.PLAY_MODE_STATUS = {
        NORMAL: "normal",
        AUTO_SPIN: "autoSpin",
        FREE_SPIN: "freeSpin",
        BONUS_ROUND: "bonusRound"
    };
    /** @const */
    constants.OPEN_DEPOSIT = "openDeposit";
    /** @const */
    constants.LAUNCH_GAME_DETAILS = "launchGameDetails";

}(window));

(function (win) {
    "use strict";
    win.com = win.com || {};
    win.com.ppb = win.com.ppb || {};
    win.com.ppb.helpers = win.com.ppb.helpers || {};
    win.com.ppb.gc = win.com.ppb.gc || {};
    win.com.ppb.gc.callbacks = win.com.ppb.gc.callbacks || {};

    /**
     * For backwards compatibility
     */
    win.com.betfair = win.com.ppb;

    var constants = win.com.ppb.constants,
        helpers = win.com.ppb.helpers,
        gc = win.com.ppb.gc,
        eventTarget = win,
        nativeFlag = win.com.ppb.native;

    win.console = win.console || {
        log: function () {
            //ignore IE
            return;
        }
    };

    win.isBetfairDebugging = win.isBetfairDebugging || false;
    win.isBetfairTest = win.isBetfairTest || false;

    win.isPPBDebugging = win.isBetfairDebugging;
    win.isPPBTest = win.isPPBTest;

    if (!nativeFlag) {
        try {
            if (win.parent && win.parent.com && win.parent.com.ppb) {
                nativeFlag = win.parent.com.ppb.native;
            }
        } catch (Exception) {
            console.log("Blocked cross-origin iframe.");
        }
    }


    win.console.ppbdebug = function (source, fnName) {
        if (win.isBetfairDebugging || win.isBetfairTest) {
            var message = "", i, finalMessage;

            if (arguments.length > 1) {
                for (i = 2; i < arguments.length; i += 1) {
                    message += arguments[i] + " ";
                }
            }
            finalMessage = source + ": [" + fnName + "] " + message;
            if (win.isBetfairDebugging) {
                console.log("%c " + finalMessage, 'color: blue;');
            } else {
                win.top.postMessage(finalMessage, "*");
                if (win.top !== win.parent) {
                    win.parent.postMessage(finalMessage, "*");
                }
            }
        }
    };

    /**
     * Helper for sending a message to the top frame
     */
    helpers.communication = {};

    helpers.communication.sendToGameWindow = function (type, payload) {
        var client = constants.GAME_CLIENT;
        var isIosNative = false;
        var sendPayload = payload || {};

        switch (nativeFlag) {
            case "ios":
                client = (win.webkit ? constants.NATIVE_IOS_WEBKIT : constants.NATIVE_IOS_WEBVIEW);
                isIosNative = true;
                break;
        }

        console.ppbdebug(client, type, JSON.stringify(payload));

        if (win.isBetfairTest) {
            return;
        }

        if (isIosNative) {
            if (win.webkit) {
                if (win.webkit.messageHandlers &&
                    win.webkit.messageHandlers[type] &&
                    win.webkit.messageHandlers[type].postMessage) {
                    win.webkit.messageHandlers[type].postMessage(sendPayload);
                    return;
                }
            } else {
                var appName = constants.NATIVE_IOS_APP_NAME;
                var escapedJsonPayload = encodeURI(JSON.stringify(sendPayload));
                var url = appName + '://' + type + "#" + escapedJsonPayload;

                var webviewComm = document.createElement('iframe');
                webviewComm.style.display = 'none';
                webviewComm.onload = function () {
                    webviewComm.parentNode.removeChild(webviewComm);
                };
                webviewComm.src = url;
                document.body.appendChild(webviewComm);
                return;
            }
        }

        if (win.top !== win.self) {
            win.top.postMessage({
                source: constants.GAME_CLIENT,
                type: type,
                payload: sendPayload
            }, '*');

            if (win.top !== win.parent) {
                win.parent.postMessage({
                    source: constants.GAME_CLIENT,
                    type: type,
                    payload: sendPayload
                }, '*');
            }
        } else {
            console.ppbdebug(constants.GAME_CLIENT, "sendToGameWindow", "Top is not accessible.");
        }
    };

    /**
     * Helper for receiving a message from the top frame
     */

    helpers.communication.receiveMessage = function (event) {
        var messageData = event.data,
            messagePayload = event.data.payload || {},
            fn;

        if (messageData.source === constants.GAME_WINDOW) {

            console.ppbdebug(constants.GAME_CLIENT, "receiveMessage",
                "Received message from from " + messageData.source + ". Message type:",
                messageData.type, "containing", JSON.stringify(messagePayload));

            fn = helpers.util.getFunction(messageData.type);
            if (fn) {
                fn(messagePayload);
            } else {
                console.ppbdebug(constants.GAME_CLIENT, "receiveMessage",
                    "No function is registered for type:", messageData.type);
            }
        }
    };

    helpers.util = {};

    helpers.util.getFunction = function (constantValue) {
        if (gc.callbacks.hasOwnProperty(constantValue)
            && (typeof gc.callbacks[constantValue] === 'function')) {
            return gc.callbacks[constantValue];
        }
        return undefined;
    };

    helpers.util.argumentsChecker = function (fnName, len, desiredLen) {
        if (len !== desiredLen) {
            console.ppbdebug(constants.GAME_CLIENT, fnName, "Arguments number doesn't match.");

            return false;
        }
        return true;
    };

    helpers.util.isTypeCheck = function (type, variableName, variable) {
        var varType = String(typeof variable);
        var typeStr = String(type);

        if (varType !== typeStr) {
            console.ppbdebug(constants.GAME_CLIENT, variableName + "\'s type doesn't match. " +
                "It should be of type " + type);

            return false;
        }
        return true;
    };

    eventTarget.addEventListener("message", helpers.communication.receiveMessage, false);

    /**
     *   Definition of the Game Client -> Game Window interactions
     **/

    /**
     * Send a notification to the Game Window for the starting of the game loading.
     */
    gc.sendGameInit = function () {
        helpers.communication.sendToGameWindow(constants.GAME_INIT);
    };

    /**
     * Send a notification to the Game Window for the starting of the game loading.
     */
    gc.sendGameLoadStarted = function () {
        helpers.communication.sendToGameWindow(constants.GAME_LOAD_STARTED);
    };

    /**
     * Send a notification to the Game Window regarding the progress of the game load.
     * @param {number} loadingPercent - Progress of the loading. Value between 0 and 100.
     */
    gc.sendGameLoadProgress = function (loadingPercent) {
        if (!helpers.util.argumentsChecker("gameLoadProgress", arguments.length, 1)
            || !helpers.util.isTypeCheck(constants.TYPE_NUMBER, "loadingPercent", loadingPercent)) {
            return;
        }
        helpers.communication.sendToGameWindow(constants.GAME_LOAD_PROGRESS,
            {loadingPercent: loadingPercent});
    };

    /**
     * Send a notification to the Game Window when the game load was completed.
     */
    gc.sendGameLoadCompleted = function () {
        helpers.communication.sendToGameWindow(constants.GAME_LOAD_COMPLETED);
    };

    /**
     * Send a notification to the Game Window when the game animation has started.
     */
    gc.sendGameAnimationStart = function () {
        helpers.communication.sendToGameWindow(constants.GAME_ANIMATION_START);
    };

    /**
     * Send a notification to the Game Window when the game animation was completed.
     */
    gc.sendGameAnimationCompleted = function () {
        helpers.communication.sendToGameWindow(constants.GAME_ANIMATION_COMPLETED);
    };

    /**
     * Send a notification to the Game Window that Game Client needs information regarding Game Window.
     */
    gc.requestGameWindowConfig = function () {
        helpers.communication.sendToGameWindow(constants.REQUEST_GAMEWINDOW_CONFIG);
    };

    /**
     * Send a notification to the Game Window for balance update.
     * @param {object} balance - Balance information. Object containing: realAmount
     * @param {number} balance.realAmount - real amount available to bet on current game
     * @param {number} balance.bonusAmount - bonus amount available to bet on current game
     * @param {string} currency Customer currency code.
     */
    gc.sendBalanceUpdate = function (balance, currency) {
        if (!helpers.util.argumentsChecker("balanceUpdate", arguments.length, 2)
            || !helpers.util.isTypeCheck(constants.TYPE_OBJECT, "balance", balance)
            || !helpers.util.isTypeCheck(constants.TYPE_STRING, "currency", currency)) {
            console.ppbdebug(constants.GAME_CLIENT, "balanceUpdate",
                "Arguments don't match. \"balance\" param's type should be object");
            return;
        }
        helpers.communication.sendToGameWindow(constants.BALANCE_UPDATE,
            {balance: balance, currency: currency});
    };

    /**
     * Send a notification to the Game Window for stake update.
     * @param {number} stakeAmount - Stake value set in current game.
     * @param {string} currency - Customer currency code.
     */
    gc.sendStakeUpdate = function (stakeAmount, currency) {
        if (!helpers.util.argumentsChecker("stakeUpdate", arguments.length, 2)
            || !helpers.util.isTypeCheck(constants.TYPE_NUMBER, "stakeAmount", stakeAmount)
            || !helpers.util.isTypeCheck(constants.TYPE_STRING, "currency", currency)) {
            return;
        }
        helpers.communication.sendToGameWindow(constants.STAKE_UPDATE,
            {stakeAmount: stakeAmount, currency: currency});
    };

    /**
     * Send a notification to the Game Window for win update. The winning amount will be sent.
     * @param {number} winAmount - Winning amount in current game.
     * @param {string} currency - Customer currency code.
     */
    gc.sendWinUpdate = function (winAmount, currency) {
        if (!helpers.util.argumentsChecker("winUpdate", arguments.length, 2)
            || !helpers.util.isTypeCheck(constants.TYPE_NUMBER, "winAmount", winAmount)
            || !helpers.util.isTypeCheck(constants.TYPE_STRING, "currency", currency)) {
            return;
        }
        helpers.communication.sendToGameWindow(constants.WIN_UPDATE,
            {winAmount: winAmount, currency: currency});
    };

    /**
     * Send a notification to the Game Window for jackpot win update.
     * The jackpot winning amount will be sent. This notification will be sent only by games with
     * jackpot features.
     * @param {number} jackpotWinAmount - Jackpot winning amount in current game
     * @param {string} currency - Customer currency code.
     */
    gc.sendJackpotWinUpdate = function (jackpotWinAmount, currency) {
        if (!helpers.util.argumentsChecker("jackpotWinUpdate", arguments.length, 2)
            || !helpers.util.isTypeCheck(constants.TYPE_NUMBER, "jackpotWinAmount", jackpotWinAmount)
            || !helpers.util.isTypeCheck(constants.TYPE_STRING, "currency", currency)) {
            return;
        }
        helpers.communication.sendToGameWindow(constants.JACKPOT_WIN_UPDATE,
            {jackpotWinAmount: jackpotWinAmount, currency: currency});
    };

    /**
     * Send a notification to the Game Window that customer clicked on the menu to open it.
     * Menu button status should change to open is closed or change to closed if open.
     */
    gc.sendToggleMenu = function () {
        helpers.communication.sendToGameWindow(constants.TOGGLE_MENU);
    };

    /**
     * Send a notification to the Game Window  that customer changed a setting available in the game.
     * @param {string} settingName - could have one of the values: sound
     * @param {string} settingValue - setting value. Depending on the setting name could be:
     *                                for sound: on|off
     */
    gc.sendSettingsUpdate = function (settingName, settingValue) {
        if (!helpers.util.argumentsChecker("settingsUpdate", arguments.length, 2)
            || !helpers.util.isTypeCheck(constants.TYPE_STRING, "settingName", settingName)
            || !helpers.util.isTypeCheck(constants.TYPE_STRING, "settingValue", settingValue)) {
            return;
        }

        helpers.communication.sendToGameWindow(constants.SETTINGS_UPDATE,
            {settingName: settingName, settingValue: settingValue});
    };

    /**
     * Send a notification to the Game Window that and error was thrown by the game.
     * Error message display should be handled by Game Window
     * @param {string} errorCode - Short string describing the error.
     *                 There should be one errorCode mapped for and errorId.
     * @param {object} errorParameters - Parameters needed to display a relevant error message to the user
     *                 (eg.: P&L for a session in case of reality check).
     */
    gc.sendErrorMessage = function (errorCode, errorMessage, errorParameters) {
        if (arguments.length > 3) {
            return;
        }
        if (arguments.length === 1
            && !helpers.util.isTypeCheck(constants.TYPE_STRING, "errorCode", errorCode)) {
            return;
        }
        if (arguments.length === 2
            && (!helpers.util.isTypeCheck(constants.TYPE_STRING, "errorCode", errorCode)
                || !helpers.util.isTypeCheck(constants.TYPE_STRING, "errorMessage", errorMessage))) {
            return;
        }
        if (arguments.length === 3
            && (!helpers.util.isTypeCheck(constants.TYPE_STRING, "errorCode", errorCode)
                || !helpers.util.isTypeCheck(constants.TYPE_STRING, "errorMessage", errorMessage)
                || !helpers.util.isTypeCheck(constants.TYPE_OBJECT, "errorParameters", errorParameters))) {
            return;
        }

        helpers.communication.sendToGameWindow(constants.ERROR_MESSAGE,
            {errorCode: errorCode, errorMessage: errorMessage, errorParameters: errorParameters});
    };

    /**
     * Send a event to the Game Window.
     * @param {string} eventName - could have one of the values: exitGame, resolveComplete, immediateExitGame
     * @param {string} [eventValue] - (optional)
     */
    gc.sendEvent = function (eventName, eventValue) {
        if (!(helpers.util.argumentsChecker("sendEvent", arguments.length, 1) ||
            helpers.util.argumentsChecker("sendEvent", arguments.length, 2))
            || !helpers.util.isTypeCheck(constants.TYPE_STRING, "eventName", eventName)) {
            return;
        }
        if (!eventValue) {
            eventValue = '';
        }

        helpers.communication.sendToGameWindow(constants.SEND_EVENT,
            {eventName: eventName, eventValue: eventValue});
    };

    /**
     * Send a notification to the game window to open another game
     * from the one that is currently opened
     * @param {string} gameCode - the game code of the game that will be opened
     */

    gc.sendGoToGame = function (gameCode) {
        if (!helpers.util.argumentsChecker("goToGame", arguments.length, 1)
            || !helpers.util.isTypeCheck(constants.TYPE_STRING, "gameCode", gameCode)) {
            return;
        }
        helpers.communication.sendToGameWindow(constants.GO_TO_GAME,
            {gameCode: gameCode});
    };

    /**
     * Send a notification to the Game Window for gamingSessionDetails update.
     * @param {object} sessionDetails - object containing: stakes, winnings and profitAndLoss
     * @param {string} currency - Customer currency code
     */
    gc.sendGamingSessionDetails = function (sessionDetails, currency) {
        if (!helpers.util.argumentsChecker("gamingSessionDetails", arguments.length, 2)
            || !helpers.util.isTypeCheck(constants.TYPE_OBJECT, "sessionDetails", sessionDetails)
            || !helpers.util.isTypeCheck(constants.TYPE_STRING, "currency", currency)) {
            console.ppbdebug(constants.GAME_CLIENT, "gamingSessionDetails",
                "Arguments don't match. \"gamingSessionDetails\" param's type should be object");
            return;
        }
        helpers.communication.sendToGameWindow(constants.GAMING_SESSION_DETAILS,
            {sessionDetails: sessionDetails, currency: currency});
    };

    /**
     * Send a notification to the Game Window in case of a session timer interval, an approaching session timer end, a session timer end or a closing session.
     * Session details message display should be handled by Game Window
     * @param sessionDetails - object
     */
    gc.sendSessionDetailsMessage = function (sessionDetails) {
        if (!helpers.util.argumentsChecker("sessionDetailsMessage", arguments.length, 1)
            || !helpers.util.isTypeCheck(constants.TYPE_OBJECT, "sessionDetails", sessionDetails)) {
            return;
        }

        helpers.communication.sendToGameWindow(constants.SESSION_DETAILS_MESSAGE,
            {sessionDetails: sessionDetails});
    };

    /**
     * Send a notification to the Game Window when the playMode changes
     * @param {PLAY_MODE_STATUS} playMode - the type of playMode the users will be (eg. normal|freeSpins|autoSpin|bonusRound)
     */
    gc.sendPlayModeUpdate = function (playMode) {
        if (!helpers.util.isTypeCheck(constants.TYPE_STRING, "playMode", playMode)
            || !(Object.values(constants.PLAY_MODE_STATUS).indexOf(playMode) > -1)) {
            console.ppbdebug(constants.GAME_CLIENT, "sendPlayModeUpdate", "playMode argument is invalid, please provider a valid value");
            return;
        }
        helpers.communication.sendToGameWindow(constants.PLAY_MODE_UPDATE, {playMode: playMode})
    };

    /**
     * Send a notification to the Game Window to open deposit page
     */
    gc.sendOpenDeposit = function () {
        helpers.communication.sendToGameWindow(constants.OPEN_DEPOSIT);
    };

    /**
     *   Definition of the Game Window -> Game Client interactions
     */

    /**
     * This is the default function. Should be overriden by registering a callback in the game client.
     *
     * Message used to notify a balance change. Game client should refresh the balance refresh
     * when this message is received and send a balance update notification back.
     */
    gc.receiveBalanceChanged = function () {
        console.ppbdebug(constants.GAME_CLIENT, "receiveBalanceChanged",
            "Please register a callback for balanceChanged");
    };

    /**
     * This is the default function. Should be overriden by registering a callback in the game client.
     *
     * Message used to notify that customer changed a setting available in the game from the Game Window.
     * @param {object} payload object with actionName and actionParam values
     *      for sound: on|off
     */
    gc.receiveSettingsUpdate = function (payload) {
        console.ppbdebug(constants.GAME_CLIENT, "receiveSettingsUpdate",
            "Please register a callback for settingsUpdate. Debug: ", payload.settingName, payload.settingValue);
    };

    /**
     * This is the default function. Should be overriden by registering a callback in the game client.
     *
     * Game client should toggle display the paytable when this message is received.
     * If paytable is displayed and the message is received it will hide the paytable
     * and if paytable is hide and the message is received it will show the paytable.
     */
    gc.receiveTogglePaytable = function () {
        console.ppbdebug(constants.GAME_CLIENT, "receiveTogglePaytable",
            "Please register a callback for togglePaytable");
    };

    /**
     * This is the default function. Should be overriden by registering a callback in the game client.
     *
     * Game client should listen to notifications and execute a specific action.
     * @param {object} payload object with actionName and actionParam values
     *                         for realityCheckAck: {option: continue|stop}
     */
    gc.receiveNotifyAction = function (payload) {
        console.ppbdebug(constants.GAME_CLIENT, "receiveNotifyAction",
            "Please register a callback for notifyAction. Debug: ", payload.actionName, payload.actionParam);
    };

    /**
     * Game client will get game configurations on this message.
     *
     * Note: in order to get this message Game Client will have to fire a
     *
     * @param {object} configuration - eg. gameClientSize: {width: no_of_pixels, height: no_of_pixels}
     */
    gc.receiveGameWindowConfig = function (configuration) {
        console.ppbdebug(constants.GAME_CLIENT, "receiveGameWindowConfig ",
            "Please register a callback for receiveGameWindowConfig . Debug: ", JSON.stringify(configuration));
    };

    /**
     * Register functions for receiving notifications from the Game Window.
     * @param {string} constantValue - should have one of the values:
     *                              constants.BALANCE_CHANGED, constants.TOGGLE_PAYTABLE,
     *                              constants.SETTINGS_UPDATE, constants.NOTIFY_ACTION
     * @param {function} fn - callback function
     */
    gc.registerCallbackFunction = function (constantValue, fn) {
        console.ppbdebug(constants.GAME_CLIENT, "registerCallbackFunction",
            "Function ", constantValue, " has been registered");
        gc.callbacks[constantValue] = fn;
    };

    /**
     * Set the object the API should listen on for messages. By default, it's window.
     */
    gc.setMessagingEventTarget = function (targetObj) {
        console.ppbdebug(constants.GAME_CLIENT, "setEventTarget",
            "The default window object has been changed to a new value.");

        eventTarget.removeEventListener("message", helpers.communication.receiveMessage, false);

        eventTarget = targetObj;
        eventTarget.addEventListener("message", helpers.communication.receiveMessage, false);
    };

    /**
     * Should stop the game autoSpin cycle. After that using gc.sendPlayModeUpdate the game should notify Game Window
     * with the new status
     */
    gc.receiveStopAutoSpin = function () {
        console.ppbdebug(constants.GAME_CLIENT, "receiveStopAutoSpin",
            "Please register a callback for receiveStopAutoSpin");
    };

    /**
     * This method will receive launch game details through postMessage
     */
    gc.receiveLaunchGameDetails = function (launchGameDetailsObj) {
        console.ppbdebug(constants.LAUNCH_GAME_DETAILS, "receiveLaunchGameDetails",
            "Please register a callback for receiveLaunchGameDetails with params", JSON.stringify(launchGameDetailsObj));
    };

    /**
     * Registering default functions
     */
    console.ppbdebug(constants.GAME_CLIENT, "Start registering default functions.");

    gc.registerCallbackFunction(constants.BALANCE_CHANGED, gc.receiveBalanceChanged);
    gc.registerCallbackFunction(constants.TOGGLE_PAYTABLE, gc.receiveTogglePaytable);
    gc.registerCallbackFunction(constants.SETTINGS_UPDATE, gc.receiveSettingsUpdate);
    gc.registerCallbackFunction(constants.NOTIFY_ACTION, gc.receiveNotifyAction);
    gc.registerCallbackFunction(constants.STOP_AUTO_SPIN, gc.receiveStopAutoSpin);
    gc.registerCallbackFunction(constants.LAUNCH_GAME_DETAILS, gc.receiveLaunchGameDetails);

    console.ppbdebug(constants.GAME_CLIENT, "Complete registering default functions.");
}(window));
